import {useCallback, useEffect, useState} from 'react';
import {useQuery, useQueryClient} from 'react-query';
import {PageService} from '../services';

export const PAGES_QUERY_KEY = 'pages';

export const useFindPages = (options = {}, queryConfig) => {
  const queryClient = useQueryClient();
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(options.size || 10);
  const [sort, setSort] = useState(options.sort);
  const {search, filters} = options;

  const fetchData = useCallback(async (page = 1) => {
    const {data, headers} = await PageService.search({page, size, search, filters, sort});
    const totalPages = Number(headers['x-total-count']);
    const hasMore = data.length === size;
    return {data, totalPages, hasMore};
  }, [size, search, filters, sort]);

  useEffect(() => {
    setPage(1);
  }, [search, filters]);

  const {
    status,
    error,
    isFetching,
    isLoading,
    isError,
    refetch,
    data = {},
  } = useQuery([PAGES_QUERY_KEY, page, search, size, sort, filters], () => fetchData(page), {
    ...queryConfig,
    refetchOnWindowFocus: false
    // keepPreviousData: true
  });

  useEffect(() => {
    if (!data?.data?.length && page > 1) {
      setPage(page - 1);
    }
  }, [page, size, search, filters, fetchData, queryClient, data]);


  return {
    page,
    status,
    ...data,
    error,
    isFetching,
    isLoading,
    isError,
    refetch,
    setPage,
    setSize,
    setSort,
    activeKey: [PAGES_QUERY_KEY, page, search, size, filters]
  };
};

